import axios from "@/plugins/axios";

let averangeController = null;
let averangeDeliveredController = null;

export default {
    abortAverangeRequests() {
        if (averangeController) {
            averangeController.abort();
            averangeController = null;
        }
    },

    abortAverangeDeliveredRequests() {
        if (averangeDeliveredController) {
            averangeDeliveredController.abort();
            averangeDeliveredController = null;
        }
    },

    async fetchAverange(
        startDate,
        endDate,
        creditorsIds = [],
        gatewaysIds = [],
        publics = [],
        approachTypes = [],
        firingType = []
    ) {
        averangeController = new AbortController();

        let params = {
            'start_date': startDate,
            'end_date': endDate
        };

        if (creditorsIds.length) params['creditors_ids'] = creditorsIds;
        if (gatewaysIds.length) params['gateway_ids'] = gatewaysIds;
        if (publics.length) params['strategy_publics'] = publics;
        if (approachTypes.length) params['approach_types'] = approachTypes;
        if (firingType.length) params['firing_type'] = firingType;

        return axios.httpApi.post("firing/averange", params, { signal: averangeController.signal });
    },

    async fetchAverangeDelivered(
        startDate,
        endDate,
        creditorsIds = [],
        gatewaysIds = [],
        publics = [],
        approachTypes = [],
        firingType = []
    ) {
        averangeDeliveredController = new AbortController();

        let params = {
            'start_date': startDate,
            'end_date': endDate
        };

        if (creditorsIds.length) params['creditors_ids'] = creditorsIds;
        if (gatewaysIds.length) params['gateway_ids'] = gatewaysIds;
        if (publics.length) params['strategy_publics'] = publics;
        if (approachTypes.length) params['approach_types'] = approachTypes;
        if (firingType.length) params['firing_type'] = firingType;

        return axios.httpApi.post("firing/averange_delivered", params, { signal: averangeDeliveredController.signal });
    },

};